import z from "zod";

export const teamMemberPriority: Record<TeamRole, number> = {
  OWNER: 3,
  ADMIN: 2,
  EDITOR: 1,
  VIEWER: 0,
};

// ============================================================================
// Request Validation Schemas
// ============================================================================

const TEAM_ROLES = ["OWNER", "ADMIN", "EDITOR", "VIEWER"] as const;
export type TeamRole = (typeof TEAM_ROLES)[number];

export const CreateTeamSchema = z.object({
  name: z.string().min(1, "Name is required"),
  institutionId: z.uuid().nullable().optional(),
});
export type CreateTeamInput = z.input<typeof CreateTeamSchema>;
export type CreateTeamDto = z.infer<typeof CreateTeamSchema>;

export const UpdateTeamSchema = CreateTeamSchema.partial();
export type UpdateTeamInput = z.input<typeof UpdateTeamSchema>;
export type UpdateTeamDto = z.infer<typeof UpdateTeamSchema>;

const addMemberRoles = Object.values(TEAM_ROLES).filter((r) => r !== "OWNER");

export const AddMemberSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.email("Must be a valid email address"),
  role: z.enum(addMemberRoles),
});
export type AddMemberInput = z.input<typeof AddMemberSchema>;
export type AddMemberDto = z.infer<typeof AddMemberSchema>;

export const UpdateMemberRoleSchema = z.object({
  memberId: z.uuid(),
  role: z.enum(TEAM_ROLES),
});
export type UpdateMemberRoleInput = z.input<typeof UpdateMemberRoleSchema>;
export type UpdateMemberRoleDto = z.infer<typeof UpdateMemberRoleSchema>;

// ============================================================================
// Response DTOs
// ============================================================================

export interface TeamSummaryDto {
  id: string;
  name: string;
}

export interface TeamDto extends TeamSummaryDto {
  institution: { id: string; name: string } | null;
  isOwner: boolean;
  isAdmin: boolean;
  isEditor: boolean;
}
